import React from "react";
import cx from "classnames";

import Container from "~/views/layout/container";

type Props = {
  className?: string;
  title: string;
  description?: string;
};

function PageHeader({ className, title, description }: Props) {
  return (
    <Container className={cx(className, "pt-5 pb-16")}>
      <h1 className="mb-3 w-full sm:w-auto font-bold text-4xl sm:text-6xl text-center tracking-[0.03em]">
        {title}
      </h1>
      <p className="text-sm text-neutral-30 leading-[24px] text-center max-w-3xl mx-auto">
        {description}
      </p>
    </Container>
  );
}

export default PageHeader;
